const vehicleParts = {
    backtray: false,
    bonnet: false,
    controlpanel: false,
    front: false,
    fronttray: false,
    frontwheel: false,
    frontwingleft: false,
    frontwingright: false,
    handlebarleft: false,
    handlebarright: false,
    leftbackwheel: false,
    leftcabdoor: false,
    leftfrontcorner: false,
    leftfrontdoor: false,
    leftfrontwheel: false,
    leftpipe: false,
    leftreardoor: false,
    leftside: false,
    rear: false,
    rearwheel: false,
    rearwindow: false,
    rearwindowLeft: false,
    rearwindowRight: false,
    rightbackwheel: false,
    rightcabdoor: false,
    rightfrontcorner: false,
    rightfrontdoor: false,
    rightfrontwheel: false,
    rightpipe: false,
    rightreardoor: false,
    rightside: false,
    roof: false,
    seat: false,
    windscreen: false
};
const carpart = {
    roof: false,
    rightreardoor: false,
    rearwindowLeft: false,
    frontwingleft: false,
    rearwindow: false,
    rear: false,
    leftreardoor: false,
    rearwindowRight: false,
    rightfrontdoor: false,
    frontwingright: false,
    bonnet: false,
    leftfrontdoor: false,
    front: false,
    windscreen: false
};
const motopart = {
    frontwheel: false,
    windscreen: false,
    controlpanel: false,
    seat: false,
    rearwheel: false,
    handlebarleft: false,
    leftside: false,
    leftpipe: false,
    handlebarright: false,
    rightside: false,
    rightpipe: false
};
const vehiclePartsIds = {
    Roof: { id: 'roof' },
    'Front bumper': { id: 'front_bumper' },
    'Rear bumper': { id: 'rear_bumper' },
    'Right headlamp': { id: 'right_headlamp' },
    'Left headlamp': { id: 'left_headlamp' },
    'Right tail lamp': { id: 'right_tail_lamp' },
    'Left tail lamp': { id: 'left_tail_lamp' },
    'Front plate': { id: 'front_plate' },
    'Rear plate': { id: 'rear_plate' },
    Windscreen: { id: 'windscreen' },
    'Rear screen': { id: 'rear_screen' },
    'Front right window': { id: 'front_right_window' },
    'Front left window': { id: 'front_left_window' },
    'Rear right window': { id: 'rear_right_window' },
    'Rear left window': { id: 'rear_left_window' },
    'Front right door': { id: 'front_right_door' },
    'Front left door': { id: 'front_left_door' },
    'Rear right door': { id: 'rear_right_door' },
    'Rear left door': { id: 'rear_left_door' },
    'Front right wing': { id: 'front_right_wing' },
    'Front left wing': { id: 'front_left_wing' },
    'Rear right wing': { id: 'rear_right_wing' },
    'Rear left wing': { id: 'rear_left_wing' },
    'Front bumper right moulding': { id: 'front_bumper_right_moulding' },
    'Front bumper left moulding': { id: 'front_bumper_left_moulding' },
    'Front bumper moulding': { id: 'front_bumper_moulding' },
    'Rear bumper right moulding': { id: 'rear_bumper_right_moulding' },
    'Rear bumper left moulding': { id: 'rear_bumper_left_moulding' },
    'Rear bumper moulding': { id: 'rear_bumper_moulding' },
    'Front right door moulding': { id: 'front_right_door_moulding' },
    'Front left door moulding': { id: 'front_left_door_moulding' },
    'Rear right door moulding': { id: 'rear_right_door_moulding' },
    'Rear left door moulding': { id: 'rear_left_door_moulding' },
    'Front right light cap': { id: 'front_right_light_cap' },
    'Front left light cap': { id: 'front_left_light_cap' },
    'Rear right light cap': { id: 'rear_right_light_cap' },
    'Rear left light cap': { id: 'rear_left_light_cap' },
    'Front emblem': { id: 'front_emblem' },
    'Rear emblem': { id: 'rear_emblem' },
    'Right sill panel': { id: 'right_sill_panel' },
    'Left sill panel': { id: 'left_sill_panel' },
    Grille: { id: 'grille' },
    'Front right rim': { id: 'front_right_rim' },
    'Front left rim': { id: 'front_left_rim' },
    'Rear right rim': { id: 'rear_right_rim' },
    'Rear left rim': { id: 'rear_left_rim' },
    'Front right door handle': { id: 'front_right_door_handle' },
    'Front left door handle': { id: 'front_left_door_handle' },
    'Rear right door handle': { id: 'rear_right_door_handle' },
    'Rear left door handle': { id: 'rear_left_door_handle' },
    'Right inferior grille': { id: 'right_inferior_grille' },
    'Left inferior grille': { id: 'left_inferior_grille' },
    'Inferior grille': { id: 'inferior_grille' },
    'Right mirror': { id: 'right_mirror' },
    'Left mirror': { id: 'left_mirror' },
    'Rear spoiler': { id: 'rear_spoiler' },
    'Front right fog light': { id: 'front_right_fog_light' },
    'Front left fog light': { id: 'front_left_fog_light' },
    'Rear right fog light': { id: 'rear_right_fog_light' },
    'Rear left fog light': { id: 'rear_left_fog_light' },
    'Rear fog light': { id: 'rear_fog_light' },
    'Front right tyre': { id: 'front_right_tyre' },
    'Front left tyre': { id: 'front_left_tyre' },
    'Rear right tyre': { id: 'rear_right_tyre' },
    'Rear left tyre': { id: 'rear_left_tyre' },
    Bonnet: { id: 'bonnet' },
    Trunk: { id: 'trunk' },
    'Front sensor': { id: 'front_sensor' },
    'Right exhaust': { id: 'right_exhaust' },
    'Left exhaust': { id: 'left_exhaust' },
    Exhaust: { id: 'exhaust' },
    'Front right fuel flap': { id: 'front_right_fuel_flap' },
    'Front left fuel flap': { id: 'front_left_fuel_flap' },
    'Front right wing arch moulding': { id: 'front_right_wing_arch_moulding' },
    'Front left wing arch moulding': { id: 'front_left_wing_arch_moulding' },
    'Front bumper right arch moulding': { id: 'front_bumper_right_arch_moulding' },
    'Front bumper left arch moulding': { id: 'front_bumper_left_arch_moulding' },
    'Front right door arch moulding': { id: 'front_right_door_arch_moulding' },
    'Front left door arch moulding': { id: 'front_left_door_arch_moulding' },
    'Rear right fuel flap': { id: 'rear_right_fuel_flap' },
    'Rear left fuel flap': { id: 'rear_left_fuel_flap' },
    'Rear right wing arch moulding': { id: 'rear_right_wing_arch_moulding' },
    'Rear left wing arch moulding': { id: 'rear_left_wing_arch_moulding' },
    'Rear bumper right arch moulding': { id: 'rear_bumper_right_arch_moulding' },
    'Rear bumper left arch moulding': { id: 'rear_bumper_left_arch_moulding' },
    'Rear right door arch moulding': { id: 'rear_right_door_arch_moulding' },
    'Rear left door arch moulding': { id: 'rear_left_door_arch_moulding' },
    'Upper center front bumper': { id: 'upper_center_front_bumper' },
    'Lower center front bumper': { id: 'lower_center_front_bumper' },
    'Upper left front bumper': { id: 'upper_left_front_bumper' },
    'Upper right front bumper': { id: 'upper_right_front_bumper' },
    'Front right towing cap': { id: 'front_right_towing_cap' },
    'Front left towing cap': { id: 'front_left_towing_cap' },
    'Headlamp right washer cap': { id: 'headlamp_right_washer_cap' },
    'Headlamp left washer cap': { id: 'headlamp_left_washer_cap' },
    'Front spoiler': { id: 'front_spoiler' },
    'Front spoiler moulding': { id: 'front_spoiler_moulding' },
    'Upper center rear bumper': { id: 'upper_center_rear_bumper' },
    'Lower center rear bumper': { id: 'lower_center_rear_bumper' },
    'Upper left rear bumper': { id: 'upper_left_rear_bumper' },
    'Upper right rear bumper': { id: 'upper_right_rear_bumper' },
    'Rear right towing cap': { id: 'rear_right_towing_cap' },
    'Rear left towing cap': { id: 'rear_left_towing_cap' },
    'Rear spoiler moulding': { id: 'rear_spoiler_moulding' }
};
export { vehicleParts, carpart, motopart, vehiclePartsIds };
